module.exports = __webpack_public_path__ + "static/media/image14.4a512aa5.png";